var _rect, _path, _path2, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 4.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1429 16.2143C16.1429 15.2281 16.9423 14.4286 17.9286 14.4286C18.9148 14.4286 19.7143 15.2281 19.7143 16.2143C19.7143 16.4895 19.6525 16.7482 19.5428 16.9792C19.3735 17.3355 19.5252 17.7616 19.8815 17.9309C20.2378 18.1002 20.6639 17.9485 20.8332 17.5922C21.032 17.1737 21.1429 16.706 21.1429 16.2143C21.1429 14.4391 19.7038 13 17.9286 13C16.1534 13 14.7143 14.4391 14.7143 16.2143C14.7143 17.1741 15.135 18.0357 15.8021 18.6247C14.7179 19.324 14 20.5424 14 21.9286V22.2857C14 22.6802 14.3198 23 14.7143 23C15.1088 23 15.4286 22.6802 15.4286 22.2857V21.9286C15.4286 20.5479 16.5479 19.4286 17.9286 19.4286C19.3093 19.4286 20.4286 20.5479 20.4286 21.9286V22.2857C20.4286 22.6802 20.7484 23 21.1429 23C21.5373 23 21.8571 22.6802 21.8571 22.2857V21.9286C21.8571 19.7589 20.0983 18 17.9286 18C16.9423 18 16.1429 17.2005 16.1429 16.2143Z",
    fill: "#777777"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 18C9 13.0294 13.0294 9 18 9C22.9706 9 27 13.0294 27 18C27 22.9706 22.9706 27 18 27C13.0294 27 9 22.9706 9 18ZM18 25.5C13.8579 25.5 10.5 22.1421 10.5 18C10.5 13.8579 13.8579 10.5 18 10.5C22.1421 10.5 25.5 13.8579 25.5 18C25.5 22.1421 22.1421 25.5 18 25.5Z",
    fill: "#777777"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 4.5,
    stroke: "#BBBBBB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/Profile.d671b36f2932ccf7afe6670ac8fcb0eb.svg";
export { ForwardRef as ReactComponent };